<template>
  <artisio-modal size="xl" :visible="modal.show" :title="$t('Google Maps')" :ok-title="$t('OK')" scrollable
                 body-class="pb-3" @show="onShowModal" @hide="onHideModal" @ok="onOkClick">
    <google-map :coordinates="coordinates" @on-coordinate-change="setCoordinates"/>
  </artisio-modal>
</template>

<script>
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import GoogleMap from "./components/GoogleMap";

  const {mapState, mapActions} = createNamespacedHelpers('inventory');
  export default {
    name: "GoogleMapsModal",
    components: {GoogleMap, ArtisioModal},
    data() {
      return {
        coordinates: {},
      }
    },
    computed: {
      ...mapState({
        modal: state => state.googleMapsModal
      })
    },
    methods: {
      ...mapActions(['hideGoogleMapsModal']),
      onOkClick() {
        this.$emit('on-coordinate-select', this.coordinates);
        this.onHideModal();
      },
      onShowModal() {
        if (Object.keys(this.modal.params).length) {
          this.setCoordinates(this.modal.params);
        }
      },
      setCoordinates(params) {
        this.coordinates = {...params};
      },
      onHideModal() {
        this.hideGoogleMapsModal();
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>